import {
    STATS_REQUEST,
    STATS_REQUEST_DOWNLOAD_LINK,
    STATS_SUCCESS,
    STATS_EMPTY,
    STATS_ERROR
  } from '@/store/actions/stats'
import Api from '@/services/Api'

const state = {
  status: '',
  logs: []
};


const getters = {
    // getLogs: state => state.logs,
};

const actions = {
  [STATS_REQUEST]: ({commit, dispatch}, args) => {
    return new Promise((resolve, reject) => {
      commit(STATS_REQUEST)

      Api().post('/stats', args)
      .then(function (response) {
        commit(STATS_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(STATS_ERROR);
        reject(error);
      });
    });
  },
  [STATS_REQUEST_DOWNLOAD_LINK]: ({commit, dispatch}, args) => {
    console.log(args);
    return new Promise((resolve, reject) => {
      commit(STATS_REQUEST)

      Api().post('/stats/get-download-link', args)
      .then(function (response) {
        commit(STATS_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(STATS_ERROR);
        reject(error);
      });
    });
  }
};

const mutations = {
  [STATS_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [STATS_SUCCESS]: (state) => {
    state.status = 'success';
  },
  [STATS_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [STATS_ERROR]: (state) => {
    state.status = 'error';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
}
